<fengstui-global-loading></fengstui-global-loading>
<div
  class="app"
  [ngClass]="{
    'app--logged': (isAuth | async),
    'app--otherpages': (!(isHome | async) && !(isAuth | async)),
    'app--dependent': (isDependent | async),
    'app--admin': fengSettings?.auth?.enableAdmin && (isAuthAdmin | async),
    'app--staging': !fengEnv?.production && !fengEnv?.maintenance && fengSettings?.auth?.staging?.enable && (isAuthStaging | async),
    'app--resale': (isResale | async) && !fengEnv?.maintenance && !fengSettings?.auth?.staging?.enable || (fengSettings?.auth?.staging?.enable && (isAuthStaging | async)),
    'app--loading': (isLoading | async)
  }"
>
  <fengstlayout-admin-bar
    *ngIf="fengSettings?.auth?.enableAdmin && (isAuthAdmin | async)"
  ></fengstlayout-admin-bar>

  <fengstlayout-staging-bar
    *ngIf="!fengEnv?.production && !fengEnv?.maintenance && fengSettings?.auth?.staging?.enable && (isAuthStaging | async)"
  ></fengstlayout-staging-bar>

  <fengstlayout-resale-bar
    *ngIf="!fengEnv?.maintenance && !fengSettings?.auth?.staging?.enable || (fengSettings?.auth?.staging?.enable && (isResale | async))"
  ></fengstlayout-resale-bar>

  <fengstlayout-header
    [isAuthAdmin]="(isAuthAdmin | async)"
    [isAuth]="(isAuth | async)"
    [isHome]="(isHome | async)"
    [isDependent]="(isDependent | async)"
    [isResale]="(isResale | async)"
    *ngIf="this.fengEnv?.production || (
      (!this.fengEnv?.maintenance && (
        (!this.fengSettings?.auth?.staging?.enable || (this.fengSettings?.auth?.staging?.enable && ((isAuthStaging | async) || (fengSettings?.auth?.enableAdmin && (isAuthAdmin | async)))))
      )) ||
      (this.fengEnv?.maintenance && fengSettings?.auth?.enableAdmin && (isAuthAdmin | async))
    )"
  ></fengstlayout-header>

  <div class="fengst-nav">
    <router-outlet (activate)="onRouterOutletActivate($event)"></router-outlet>
  </div>

  <fengstlayout-footer
    [isAuthAdmin]="(isAuthAdmin | async)"
    [isAuth]="(isAuth | async)"
    [isHome]="(isHome | async)"
    [isDependent]="(isDependent | async)"
    [isResale]="(isResale | async)"
    *ngIf="this.fengEnv?.production || (
      (!this.fengEnv?.maintenance && (
        (!this.fengSettings?.auth?.staging?.enable || (this.fengSettings?.auth?.staging?.enable && ((isAuthStaging | async) || (fengSettings?.auth?.enableAdmin && (isAuthAdmin | async)))))
      )) ||
      (this.fengEnv?.maintenance && fengSettings?.auth?.enableAdmin && (isAuthAdmin | async))
    )"
  ></fengstlayout-footer>

  <!-- *ngIf="fengEnv?.production || ((fengSettings?.auth?.enableAdmin && (isAuthAdmin | async))) || (!fengEnv?.maintenance && (!fengSettings?.auth?.staging?.enable || (isAuthStaging | async))))" -->

</div>
